import { render, staticRenderFns } from "./OverlayHeader.vue?vue&type=template&id=481f12c0&"
import script from "./OverlayHeader.vue?vue&type=script&lang=js&"
export * from "./OverlayHeader.vue?vue&type=script&lang=js&"
import style0 from "./OverlayHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports